import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTheme } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import TextField from '../../../styles/templates/DSTextField';

import DetailsSection from './DetailsSection';
import { formValidators, getErrorMessage } from '../../../helpers/formErrorMessages';
import { generalSettingsState } from './helper';
import { getIconColour } from '../../../helpers/app';
import SettingsIcon from '../../../assets/icons/settings';
import { SectionRow, GridRow, ExpandContent } from './styles';
import { ApplicationInterface } from '../../../interfaces/application';

type PropsType = {
  formHook: UseFormReturn<ApplicationInterface>;
  expand?: boolean;
  onClick: () => void;
  appID: string;
  namespace: string;
};

type ExpandPropsType = {
  formHook: UseFormReturn<ApplicationInterface>;
  appID: string;
  namespace: string;
};

const ExpandedGeneralSettings: React.FC<ExpandPropsType> = ({ formHook, appID, namespace }) => {
  const {
    register,
    formState: { errors },
  } = formHook;

  return (
    <ExpandContent>
      <GridRow>
        <TextField
          inputProps={register('info.name', { required: true })}
          id="name"
          label="Application Name"
          variant="outlined"
          autoComplete="off"
          error={!!errors.info?.name}
          helperText={getErrorMessage(errors.info?.name)}
          focused={false}
        />

        <TextField
          inputProps={register('info.website', {
            required: true,
            validate: formValidators.website,
          })}
          id="website"
          label="Application Website"
          variant="outlined"
          className="formInput"
          autoComplete="off"
          error={!!errors.info?.website}
          helperText={getErrorMessage(errors.info?.website)}
          focused={false}
        />
      </GridRow>

      <SectionRow className="ds-section-expand-row">
        <TextField
          inputProps={register('info.supportEmail', { required: true })}
          id="supportEmail"
          label="Support Email"
          variant="outlined"
          className="formInput"
          autoComplete="off"
          error={!!errors.info?.supportEmail}
          helperText={getErrorMessage(errors.info?.supportEmail)}
          focused={false}
        />
      </SectionRow>

      <GridRow>
        <div>
          <Typography>Application ID</Typography>
          <Typography>{appID}</Typography>
        </div>

        <div>
          <Typography>Application Namespace</Typography>
          <Typography>{namespace}</Typography>
        </div>
      </GridRow>
    </ExpandContent>
  );
};

const GeneralSettings: React.FC<PropsType> = ({
  formHook,
  expand = false,
  onClick,
  appID,
  namespace,
}) => {
  const type = generalSettingsState(formHook);
  const theme = useTheme();

  return (
    <DetailsSection
      icon={<SettingsIcon stroke={getIconColour(type, theme)} />}
      title="General Settings"
      description="Project Name, ID, namespace, and team information."
      expand={expand}
      onClick={onClick}
      type={type}
    >
      <ExpandedGeneralSettings formHook={formHook} appID={appID} namespace={namespace} />
    </DetailsSection>
  );
};

export default GeneralSettings;
